import { create } from 'zustand';
import { ITicket, ITicketDateStore, ITicketListRefresh } from './interface';
import moment from 'moment-jalaali';

export const useTicketselect = create<ITicket>((set) => ({
  ticket: null,
  setTicket: (data) => {
    set({ ticket: data });
  },
}));
export const useTicketListRefresh = create<ITicketListRefresh>((set) => ({
  ticketListRefresh: false,
  setTicketListRefresh: (data) => {
    set({ ticketListRefresh: data });
  },
}));

const initialStartDate = moment().subtract(7, 'days').format('jYYYY/jMM/jDD');
const initialEndDate = moment().format('jYYYY/jMM/jDD');
export const useTicketDateStore = create<ITicketDateStore>((set) => ({
  startDate: initialStartDate,
  endDate: initialEndDate,
  ticketCreated: false,
  backupStartDate: null,
  backupEndDate: null,
  ticketStatusType: { value: null, label: 'همه' },

  setStartDate: (date) => set({ startDate: date }),
  setEndDate: (date) => set({ endDate: date }),
  setTicketCreated: (value) => set({ ticketCreated: value }),
  setBackupStartDate: (date) => set({ backupStartDate: date }),
  setBackupEndDate: (date) => set({ backupEndDate: date }),
  setTicketStatusType: (status) => set({ ticketStatusType: status }),
}));
